<template>
	<span class="wauchat">
		<b-link :href="urlWhatapp+phone" target="_blank" ><b-img  src="@/assets/whatsapp.svg" class="socialIcondiv--icon" width="20px;"></b-img></b-link> 
		
	</span>
</template> 
<script> 
/* const separator = {
  template: '<hr style="border-color: rgba(0, 0, 0, 0.1); margin: 20px;">'
}; */
	//var today 	= new Date();
	//var timenow = '?'+today.getHours()+ today.getMinutes()+today.getSeconds();
	
export default {
  name: 'MenuPanel',
  components: {
  
  },
  props: {   
   phone:{type: String},   
   listtype:{type: String}
  },
  mounted(){
  //this.inLodcard;
  if(window.innerWidth < 700){
	//this.urlWhatapp='https://wa.me/send?text=&phone=918920670756';
	this.urlWhatapp='https://api.whatsapp.com/send?text=&phone=91';
 }
  
	
  },
  computed: {
    //
  },
  data() {
    return{
     collapsed: false,
	 urlWhatapp:'https://web.whatsapp.com/send?text=&phone=91',
	 updateWahtappUrluser: this.$root.WEBAPI+'secureapi/updateUserWhatsappStatus',
	 updateWahtappUrlmark: this.$root.WEBAPI+'secureapi/updateMarkWhatsappStatus',
	 updateWahtappUrlmarkcustomr: this.$root.WEBAPI+'secureapi/updateMarkCustomerWhatsappStatus',

    }
  },
  methods:{
	/* inLodcard(){
	this.cartHeader ='
	} */
	updateWappstatus(userIdl,listtypel,mobile){
		console.log(userIdl+'---'+listtypel);
		var self = this;
			var userId	= userIdl;
			
			var reqUri=  self.updateWahtappUrlmark;
			if(listtypel=='user'){
				reqUri= self.updateWahtappUrluser
			}
			if(listtypel=='markcustomr'){
				reqUri= self.updateWahtappUrlmarkcustomr
			}
			
			self.axios.post(reqUri, {
				userId:userId,
				mobile:mobile,
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
						console.log('as');
				}
			})
			.catch(function (error) {
				alert(error);
			});
		
	
	},
	onToggleCollapse() {
			/* console.log('Ram Ram'+collapsed);
			this.collapsed = collapsed; */
			console.log('DataR'+this.collapsed);
			
			 if(this.collapsed){
				this.collapsed = false;
				
			 }else{
				this.collapsed = true;
				
			 }
			
			 /*this.posmenuProfile = collapsed;
			 this.navppnew = collapsed;
			 if(!collapsed){
				this.posmenu = true;
				
			 }else{
				this.posmenu = false;
				
			 }*/
		},
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
	.waimg{ width: 42px;
    margin-top: -3px;
    margin-left: -8px;
	}


</style>
